export default {
    init() {
        //
    },

    finalize: function () {
        document.addEventListener('scroll', () => {
            const scrollY = window.scrollY || window.pageYOffset;

            if (scrollY > $('#chair-description').position().top) {
                document.getElementById('floating-customizer').classList.add('visible');
            } else {
                document.getElementById('floating-customizer').classList.remove('visible');
            }
        });

        const fabric = $('[data-attribute_name=attribute_pa_fabric]');
        const nailhead = $('[data-attribute_name=attribute_pa_nailhead]');

        fabric.select2({
            minimumResultsForSearch: Infinity,
            dropdownCssClass: 'no-search',
        });

        // fabric.on('select2:opening select2:closing', (event) => {
        //     const form = $(event.target);
        //     const searchField = form.parent().find('.select2-search__field');
        //     searchField.prop('disabled', true);
        // });
        //
        fabric.on('select2:selecting', (event) => {
            const form = $(event.target);
            const this_product = form.parents('.product');
            const this_image_wrapper = this_product.find('.woocommerce-product-gallery__wrapper');

            fabric.select2('close');
            this_image_wrapper.animate({opacity: 0}, 200, () => {
                // remove prevented flag
                delete event.params.args.prevented;

                // // Call trigger on the observer with select2 instance as context
                this_image_wrapper.find('img').removeAttr('src');
                fabric.trigger({
                    type: 'select2:select',
                    params:  event.params.args,
                });
            });
            return false;
        });

        fabric.on('select2:select', (event) => {
            const form = $(event.target);
            const this_product = form.parents('.product');
            const this_image_wrapper = this_product.find('.woocommerce-product-gallery__wrapper');
            this_product
                .find('.variations option[value="'+ event.params.data.id +'"]')
                .prop('selected', true)
                .trigger('change');
            this_image_wrapper.find('img').on('load', () => {
                this_image_wrapper.animate({opacity: 1}, 200);
            });
        });

        // fabric.on('change', (event) => {
        //     const form = $(event.target);
        //
        //     form.find('input[name="variation_id"], input.variation_id').val('').change();
        //     form.find('.wc-no-matching-variations').remove();
        //
        //     if (form.useAjax) {
        //         form.trigger('check_variations');
        //     } else {
        //         form.trigger('woocommerce_variation_select_change');
        //         form.trigger('check_variations');
        //     }
        //
        //     // Custom event for when variation selection has been changed
        //     form.trigger('woocommerce_variation_has_changed');
        //     form.trigger('woocommerce_update_variation_values');
        //
        //     const this_product = form.parents('.product');
        //     const this_image_wrapper = this_product.find('.woocommerce-product-gallery__wrapper');
        //
        //     this_image_wrapper.animate({opacity: 0}, 200, () => {
        //         fabric.not(form).val(form.value);
        //
        //         this_image_wrapper.find('img').on('load', () => {
        //             this_image_wrapper.animate({opacity: 1}, 200);
        //         });
        //     });
        // });

        nailhead.on('change', (event) => {
            nailhead.not(event.target).val(event.target.value);
        });

        ///////////////////////////////////////////////
        // Fade out and in chair on variation change //
        ///////////////////////////////////////////////
        // $('[data-swatch]').bind('click', function () {
        //     const this_swatch = $(this);
        //     const this_product = this_swatch.parents('.single-product');
        //
        //     this_swatch.siblings('[data-swatch]').removeClass('active');
        //     this_swatch.addClass('active');
        //
        //
        //     const this_product_fabric = this_product.find('[data-attribute-type="fabric"] [data-swatch].active').data('swatch-title');
        //     const this_product_nailhead = this_product.find('[data-attribute-type="nailhead"] [data-swatch].active').data('swatch-title');
        //     const this_image_wrapper = this_product.find('.woocommerce-product-gallery__image');
        //
        //     var product_var_text = this_product_fabric;
        //
        //     if (this_product_nailhead) {
        //         product_var_text += ' + ' + this_product_nailhead;
        //     }
        //     this_product.find('.product_variation').text(product_var_text);
        //
        //     this_image_wrapper.animate({opacity: 0}, 200, function () {
        //         this_product
        //             .find('.variations option[value="' + this_swatch.data('swatch') + '"]')
        //             .prop('selected', true)
        //             .trigger('change');
        //
        //         this_image_wrapper.find('img').on('load', function () {
        //             this_image_wrapper.animate({opacity: 1}, 200);
        //         });
        //     });
        // });
    },

    // check if element is in view
    inView(element) {
        const elementHeight = element.clientHeight;
        // get window height
        const windowHeight = window.innerHeight;
        // get number of pixels that the document is scrolled
        const scrollY = window.scrollY || window.pageYOffset;

        // get current scroll position (distance from the top of the page to the bottom of the current viewport)
        const scrollPosition = scrollY + windowHeight;
        // get element position (distance from the top of the page to the bottom of the element)
        const elementPosition = element.getBoundingClientRect().top + scrollY + elementHeight;
        console.log(elementHeight, windowHeight, scrollY, scrollPosition, elementPosition);

        // is scroll position greater than element position? (is element in view?)
        return scrollPosition > elementPosition;
    },

    // animate element when it is in view
    animate(element) {
        // is element in view?
        if (this.inView(element)) {
            // element is in view, add class to element
            element.classList.add('animate');
        }
    },
};




// WEBPACK FOOTER //
// ./scripts/routes/single-product.js